/**
 * Converts a string into a URL-friendly slug
 * @param {string} text - The text to slugify
 * @returns {string} The slugified text
 */
export const slugify = (text) => {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')     // Replace spaces with -
    .replace(/[^\w-]+/g, '')    // Remove all non-word chars
    .replace(/--+/g, '-')       // Replace multiple - with single -
    .replace(/^-+/, '')         // Trim - from start of text
    .replace(/-+$/, '');        // Trim - from end of text
};

/**
 * Finds a department in a list by its ID or its slugified name
 * @param {Array} departments - The list of departments
 * @param {string} identifier - The ID or slug to search for
 * @returns {Object|null} The found department or null
 */
export const findDepartmentByIdOrSlug = (departments, identifier) => {
  if (!departments || !identifier) return null;
  
  return departments.find(dept => 
    dept.id === identifier || 
    slugify(dept.name) === identifier.toLowerCase()
  );
};

